<script lang="ts">
	import Header from '#blocks/header.svelte'
	import Sidekick from '#blocks/sidekick.svelte'
	import { Storyblok } from '#library/storyblok.svelte.ts'
	import type { Alumni } from '#library/types.ts'

	interface Props {
		data: Storyblok<Alumni>
	}

	let { data }: Props = $props()

	const content = $derived(data.story?.content)
</script>

<Header />

<div class="contain">
	<Sidekick blok={{ image: content?.photo, body: content?.body, flip: true }} />
</div>

<style lang="css">
	.contain {
		padding-bottom: var(--padding-bottom, var(--padding-default));
	}
</style>
